import React from 'react';
import { connect } from "react-redux";
import TextField from '../components/InputFields/TextField';
import { createStructuredSelector } from 'reselect';
import { Link } from 'react-router-dom';
import { selectIsAuthenticated, selectLoading } from '../redux/auth/authSelector';
import * as Yup from 'yup'

import { _SIGN_IN } from '../redux/auth/authActions';
import { Form, Formik } from 'formik';


const Login = ({ _SIGN_IN, isAuthenticated}) => {

    const validate = Yup.object({
        email: Yup.string()
            .email('Email is invalid')
            .required('Email is required'),
        password: Yup.string()
            .required('Password is required'),
    })

  return (

    <div className='login'>
        <div className="onboard__container">
            <h1>Log In</h1>
            <Formik

                initialValues={{ 
                    email: '',                    
                    password: '',
                }}

                validationSchema={validate}

                onSubmit = {( values, {resetForm, setErrors}) => {
                    console.log('Form values', values)
                }}
            >

                {formik => (

                    <div className="form__container">
                        <Form action="#" className="onboard__form__control">

                            <TextField label="Email" name='email' type="email" />

                            <TextField label="Password" name='password' type="password" />

                            <div className="register__or__forgot__password">
                                <Link to="/" style={{ textDecoration: 'none' }} ><h5 className='register__here'>Register here</h5></Link>
                                <Link to="/forgot-password" style={{ textDecoration: 'none' }}><h5 className="forgot__password">Forgot password ?</h5></Link> 
                            </div>

                            <input className='btn onboard__input submit' type="submit" value="Submit" />
                        </Form>
                    </div>
                )}              
            </Formik>
        </div>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
    isAuthenticated: selectIsAuthenticated,
    loading: selectLoading,
})

const mapDispatchToProps = (dispatch) => ({
    _SIGN_IN: (UserCredentials, setLoadButton) => dispatch(_SIGN_IN(UserCredentials, setLoadButton))
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)